const Constants = {
    toolTipcard:
        'Find your 19-digit number on the back of the card. If using an e-Gift card, find your 19-digit e-Gift card number and ID number at the top of your email, just under the amount.',
    toolTipcardV2:
        'Enter the gift card number found on your card or e-Gift email (16-19 digits). See the guide below for help.',
    toolTipPin: 'Scratch off your 4-digit PIN number, which is found on the back of your card.',
    toolTipPinV2:
        'Enter the PIN found on the back of your card (4-8 digits). See the guide below for help.',
    labelPin: 'PIN',
    labelGC: 'Gift Card Number',
    INVISIBLE: 'invisible',
    VISIBLE: 'visible',
    GC_CAPTCHA: 'gc_captcha',
    BLUR: 'blur',
    CHECK_ANOTHER_CARD: 'Check Another Card',
    CHECK_BALANCE: 'Check Balance',
    CARD_ERROR: 'Enter a valid 19-digit number',
    CARD_ERROR_V2: 'Enter a valid 16-digit or 19-digit gift card number',
    PIN_ERROR: 'Enter a valid 4-digit number',
    PIN_ERROR_V2: 'Enter a valid 4-digit or 8-digit PIN',
    BLANK: '',
    GIFT_CARD_INSTRUCTION_MESSAGE:
        'Gift cards vary in design, so the card number and PIN may appear in different locations. Use the guides below to find yours.',
};

export default Constants;
